import React, { Component } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Header from './Header'
import Inicio from '../pages/Inicio'
import Nosotros from '../pages/Nosotros'
import Dormitorios from '../pages/Dormitorios'
import Contacto from '../pages/Contacto'
import Login from '../pages/Login'
import Register from '../pages/Register'
import Error from './Error'
import '../lib/Script'

class Router extends Component {
    render(){
        return(
            <BrowserRouter>
                <React.Fragment>
                    <Header />
                    <Switch>
                        <Route exact path="/" component={Inicio}/>
                        <Route exact path="/nosotros" component={Nosotros}/>
                        <Route path="/dormitorios" component={Dormitorios}/>
                        <Route exact path="/contacto" component={Contacto}/>
                        <Route exact path="/login" component={Login}/>
                        <Route exact path="/register" component={Register}/>
                        <Route component={Error} />
                    </Switch>
                </React.Fragment>
            </BrowserRouter>
        )
    }
}
export default Router